/* eslint-disable */
export default {
  noActiveCalls: 'Keine aktiven Anrufe',
  noRecords: 'Keine Treffer gefunden.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
